<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Zls5jo/images/cover.jpg?1684514755366" alt="This image is the cover for the book Rule of Thumb: A Guide to Communication Basics for Small Business Owners & Managers, Rule of Thumb"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rule of Thumb: A Guide to Communication Basics for Small Business Owners & Managers, Rule of Thumb
      </h1>
      <p class="bookDescription body article font2">
        <p>Rule of Thumb: A Guide to Communication for Small Business Owners and Managers is an introductory guide for first-time entrepreneurs and small business owners seeking to gain a basic understanding of identifying and adopting effective communication skills. Just how important are effective communication skills? The answer is critically important, especially in the professional world. Employer surveys consistently reveal the importance of effective communication skills for securing a job, as well as for job performance, career advancement and the overall success of a business. Good communication reflects directly on the company, creating trust and presenting a professional image to build better business relationships. No one is born an excellent communicator. Excellent communication skills are learned and anyone can learn the skills to communicate effectively in both written and oral messages. This book provides basic information to help you improve both written and oral communication skills. It shows you how to be kind to your readers by making what you've written interesting and easy to understand. Keep it clear. Keep it simple. Keep it to the point.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marian Shalander Kaiser
      </h2>
      
      <p class="authorDescription body article">Marian Shalander Kaiser is an author, the owner of WriteWorks, Inc., and an adjunct instructor at the University of Nebraska at Omaha (UNO), teaching Managerial Communications. Her professional experience includes serving as a Corporate and Foundation Manager for the Omaha Performing Arts Society, teaching high school and college English and Oral Communications, serving as Executive Director of the Bluffs Arts Council, and filling the position of Associate Director of the National Conference for Community and Justice (NCCJ) Midlands Region. Marian is a graduate of the University of Nebraska at Lincoln, earning a B.S. in English and Education. She earned a Master of Arts degree in English from UNO, a certificate in nonprofit management from UNO, and a certificate in arts administration and management from the University of Massachusetts at Amherst. Kaiser is also a bilingual speaker of Czeck and English.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BQB Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ecdf90a